import { SprintMutationResult, useSprintMutation, useSprintQueryClient } from "sprint-common-web";

import { UpdateAudioCloudFileRequest } from "../../../../../../../common/api/master-api/cloud-files/update/UpdateAudioCloudFileRequest";
import { UpdateSubtitleCloudFileRequest } from "../../../../../../../common/api/master-api/cloud-files/update/UpdateSubtitleCloudFileRequest";
import { UpdateVideoCloudFileRequest } from "../../../../../../../common/api/master-api/cloud-files/update/UpdateVideoCloudFileRequest";
import { useCloudFileApi } from "../../../../../../../common/api/master-api/cloud-files/useCloudFileApi";
import { CloudFileQueryKey } from "../../../../common/CloudFileQueryKey";

export interface UseAssociateCloudFile {
    updateVideoCloudFile: SprintMutationResult<UpdateVideoCloudFileRequest, void>;
    updateAudioCloudFile: SprintMutationResult<UpdateAudioCloudFileRequest, void>;
    updateSubtitleCloudFile: SprintMutationResult<UpdateSubtitleCloudFileRequest, void>;
}

export const useAssociateCloudFile = ({ invalidationKey }: { invalidationKey?: string }): UseAssociateCloudFile => {
    const cloudFileApi = useCloudFileApi();
    const sprintQueryClient = useSprintQueryClient();

    const invalidateQuery = async () => {
        await sprintQueryClient.invalidateQueries({
            queryKey: [CloudFileQueryKey.CloudFileDetails, invalidationKey]
        });
    };

    const updateVideoCloudFile = useSprintMutation<UpdateVideoCloudFileRequest>({
        mutationFn: async (request: UpdateVideoCloudFileRequest) => {
            return cloudFileApi.updateVideoCloudFile(request);
        },
        onSettled: invalidateQuery
    });

    const updateAudioCloudFile = useSprintMutation<UpdateAudioCloudFileRequest>({
        mutationFn: async (request: UpdateAudioCloudFileRequest) => {
            return cloudFileApi.updateAudioCloudFile(request);
        },
        onSettled: invalidateQuery
    });

    const updateSubtitleCloudFile = useSprintMutation<UpdateSubtitleCloudFileRequest>({
        mutationFn: async (request: UpdateSubtitleCloudFileRequest) => {
            return cloudFileApi.updateSubtitleCloudFile(request);
        },
        onSettled: invalidateQuery
    });

    return {
        updateVideoCloudFile,
        updateAudioCloudFile,
        updateSubtitleCloudFile
    };
};
